import { Button } from "@babackapp/ui/components/button";
import useTranslation from "@babackapp/translations/use-translation";
import { TrashIcon } from "@radix-ui/react-icons";
import CopyBtn from "@/components/copy-btn";
import DeleteApiKeyDialog from "./delete-api-key-dialog";

type ApiKey = {
  id: string;
  label: string;
  token: string;
};

interface ApiKeyRowProps {
  apiKey: ApiKey;
  onDelete: (keyId: string) => void;
  isDeletePending: boolean;
}

export default function ApiKeyRow({
  apiKey,
  onDelete,
  isDeletePending,
}: ApiKeyRowProps) {
  const t = useTranslation();

  return (
    <div className="flex items-center gap-3 py-3 border-b last:border-b-0">
      <div className="flex flex-col flex-1 min-w-0">
        <span className="text-sm font-medium truncate">{apiKey.label}</span>
        <CopyBtn value={apiKey.token}>
          <span className="text-xs text-muted-foreground font-mono truncate">
            {apiKey.token.slice(0, 14)}••••••••••••••••
          </span>
        </CopyBtn>
      </div>

      <DeleteApiKeyDialog onConfirm={() => onDelete(apiKey.id)}>
        <Button
          size="icon"
          variant="ghost"
          className="text-destructive hover:text-destructive shrink-0"
          disabled={isDeletePending}
          aria-label={t("settings.integrations.api.deleteKey")}
        >
          <TrashIcon className="size-4" />
        </Button>
      </DeleteApiKeyDialog>
    </div>
  );
}
